import { connect } from 'react-redux';
import Shipment from './Shipment';
import {
  getShipment,
  getShipmentConsignmentAccept,
  getShipmentReject,
  getShipmentActRemoveMh3,
  getShipmentErrorClear
} from '../../../store/actions/shipment';
import { modalErrorOpen } from '../../../store/actions/modalError';
import {
  modalShipmentCheckFIFOOpen,
  modalShipmentCheckFIFOClose,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentRedeemConsignmentClose,
  modalSKZipOpen,
  modalShipmentCancelReasonConsignmentClose,
  modalAwaitingProcessingStartOpen,
  modalShipmentAddReportOverdueOpen,
  modalShipmentSZRebindingOpen, modalShipmentClientArrivalDateOpen
} from '../../../store/actions/modal';
import { getProcessingStartCancel, getProcessingStartClear } from '../../../store/actions/processing';
// eslint-disable-next-line import/named
import { setSelectedDocItems } from '../../../store/actions/documents';

const mapStateToProps = ({
  settingsReducer,
  shipmentReducer,
  stockReducer,
  tabsReducer,
  userReducer
}) => ({
  settingsReducer,
  shipmentReducer,
  stockReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getShipment,
  getShipmentConsignmentAccept,
  getShipmentReject,
  getShipmentActRemoveMh3,
  modalErrorOpen,
  getShipmentErrorClear,
  modalShipmentCheckFIFOOpen,
  modalShipmentCheckFIFOClose,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentRedeemConsignmentClose,
  modalSKZipOpen,
  modalShipmentCancelReasonConsignmentClose,
  modalAwaitingProcessingStartOpen,
  getProcessingStartCancel,
  getProcessingStartClear,
  modalShipmentAddReportOverdueOpen,
  modalShipmentSZRebindingOpen,
  modalShipmentClientArrivalDateOpen,
  setSelectedDocItems
};

const ShipmentConsignment = connect(
  mapStateToProps,
  mapDispatchToProps
)(Shipment);

export default ShipmentConsignment;
